<template>
  <path
    d="M8.11997 14.7102L12 10.8302L15.88 14.7102C16.27 15.1002 16.9 15.1002 17.29 14.7102C17.68 14.3202 17.68 13.6902 17.29 13.3002L12.7 8.71016C12.31 8.32016 11.68 8.32016 11.29 8.71016L6.69997 13.3002C6.30997 13.6902 6.30997 14.3202 6.69997 14.7102C7.08997 15.0902 7.72997 15.1002 8.11997 14.7102Z"
  />
</template>
